export const MomentDateFormat = {
    DateOnlyUTCHyphenated: 'YYYY-MM-DD',
    DateOnlyUTCSlashes: 'YYYY/MM/DD',
    MonthDayYearHyphensNoLeading: 'M-DD-YYYY',
    MonthDayYearHyphensLeading: 'MM-DD-YYYY',
    MonthDayYearSlashesNoLeading: 'M/DD/YYYY',
    MonthDayYearSlashesLeading: 'MM/DD/YYYY',
    DateTimeShortAnte: 'M/D/YY, h:mm A',
    WeekDayNameAndDate: 'dddd, MMMM Do YYYY',
    ApiUrlRequest: 'YYYYMMDD',
    ShortMonthAndDay: 'DD ddd MMM YYYY',
    DateTimeLocalInput: 'YYYY-MM-DDTHH:mm',
    MonthAndYear: 'MMMM YYYY',
};
